module.exports = __webpack_public_path__ + "img/FR11425.c3555807.png";